export default {
  title: 'Kétfaktoros hitelesítés',
  subtitle: 'Védd a fiókodat extra biztonsági réteggel',
  
  status: {
    enabled: 'Bekapcsolva',
    disabled: 'Kikapcsolva',
    required: 'Kötelező',
    optional: 'Opcionális',
  },

  setup: {
    title: 'MFA beállítása',
    subtitle: 'Állítsd be a kétfaktoros hitelesítést',
    required: 'A kétfaktoros hitelesítés bekapcsolása kötelező!',
    
    steps: {
      info: {
        title: 'Információ',
        description: 'Mire lesz szükséged',
      },
      generate: {
        title: 'QR kód',
        description: 'Szkenneld be a QR kódot',
      },
      verify: {
        title: 'Ellenőrzés',
        description: 'Add meg a 6 számjegyű kódot',
      },
      reauth: {
        title: 'Újra-hitelesítés',
        description: 'Biztonsági ellenőrzés szükséges',
      },
    },

    info: {
      title: 'Mire lesz szükséged:',
      apps: [
        'Google Authenticator alkalmazás',
        'Microsoft Authenticator alkalmazás',
        'Vagy bármely TOTP kompatibilis app',
      ],
      description: 'A kétfaktoros hitelesítés extra védelmet nyújt a fiókodnak. Bejelentkezéskor a jelszó mellett egy 6 számjegyű kódot is meg kell adnod.',
      benefits: {
        title: 'Előnyök:',
        items: [
          'Fokozott biztonság',
          'Védelem illetéktelen hozzáférés ellen',
          'Megfelelés biztonsági előírásoknak',
        ],
      },
    },

    qrCode: {
      title: 'Szkenneld be a QR kódot',
      description: 'Nyisd meg az Authenticator alkalmazást és szkenneld be ezt a QR kódot:',
      manualKey: 'Manuális beállítási kulcs:',
      manualKeyDescription: 'Mentsd el biztonságos helyre, ha elveszítenéd a hozzáférést!',
      copyKey: 'Kulcs másolása',
      keyCopied: 'Kulcs vágólapra másolva!',
    },

    verify: {
      title: 'Add meg a 6 számjegyű kódot',
      description: 'Add meg az Authenticator alkalmazásodból a 6 számjegyű kódot:',
      placeholder: '000000',
      codeRefreshes: 'A kód 30 másodpercenként változik',
    },

    reauth: {
      title: 'Újra-hitelesítés szükséges',
      description: 'Biztonsági okokból add meg a jelszavadat a kétfaktoros hitelesítés beállításához.',
      passwordLabel: 'Jelszó',
      passwordPlaceholder: 'Add meg a jelszavadat',
    },

    buttons: {
      cancel: 'Mégse',
      back: 'Vissza',
      continue: 'Folytatás',
      generateQR: 'QR kód generálása',
      enable: 'Bekapcsolás',
      verifying: 'Ellenőrzés...',
      generating: 'Generálás...',
    },

    messages: {
      success: 'Kétfaktoros hitelesítés sikeresen bekapcsolva!',
      successDescription: 'A fiókod most már védve van. Következő bejelentkezéskor meg kell adnod a 6 számjegyű kódot.',
      error: 'Hiba történt az MFA beállítása során',
      invalidCode: 'Érvénytelen ellenőrző kód',
      wrongPassword: 'Hibás jelszó',
      reauthRequired: 'Biztonsági okokból újra be kell jelentkezned',
    },
  },

  verification: {
    title: 'Kétfaktoros hitelesítés',
    description: 'Add meg az Authenticator alkalmazásodból a 6 számjegyű kódot',
    codeLabel: 'Ellenőrző kód',
    codePlaceholder: '000000',
    codeRefreshes: 'A kód 30 másodpercenként változik',
    useBackupCode: 'Backup kód használata',
    trustDevice: 'Eszköz megbízhatónak jelölése 30 napra',
    
    buttons: {
      verify: 'Bejelentkezés',
      verifying: 'Ellenőrzés...',
      cancel: 'Mégse',
    },

    messages: {
      success: 'Sikeres bejelentkezés!',
      invalidCode: 'Érvénytelen kód. Próbáld újra!',
      expiredCode: 'A kód lejárt. Kérj újat!',
      error: 'Hiba történt az ellenőrzés során',
      quotaExceeded: '⏳ Túl sok próbálkozás! Kérlek várj 15-30 percet, majd próbáld újra. A Firebase napi kvótája kimerült, de hamarosan visszaáll.',
      tooManyAttempts: 'Túl sok sikertelen próbálkozás. Kérlek várj egy kicsit, majd próbáld újra.',
    },

    tip: {
      title: 'Tipp:',
      description: 'Nyisd meg az Authenticator alkalmazást a telefonodon és add meg az aktuális 6 számjegyű kódot.',
    },
  },

  backupCodes: {
    title: 'Backup kódok',
    description: 'Ezek a kódok egyszer használhatók, ha nem férsz hozzá az Authenticator alkalmazásodhoz.',
    warning: 'Mentsd el ezeket a kódokat biztonságos helyre!',
    
    generate: 'Új kódok generálása',
    regenerate: 'Kódok újragenerálása',
    download: 'Letöltés',
    print: 'Nyomtatás',
    copy: 'Másolás',
    
    status: {
      unused: 'Nem használt',
      used: 'Használva',
      usedAt: 'Használva:',
    },

    remaining: '{count} kód maradt',
    
    messages: {
      generated: 'Backup kódok sikeresen generálva!',
      regenerated: 'Backup kódok újragenerálva!',
      copied: 'Kódok vágólapra másolva!',
      downloadSuccess: 'Kódok letöltve!',
      error: 'Hiba a backup kódok generálása során',
      confirmRegenerate: 'Biztosan újragenerálod a backup kódokat? A régi kódok érvénytelenné válnak!',
    },
  },

  trustedDevices: {
    title: 'Megbízható eszközök',
    description: 'Ezeken az eszközökön nem kell megadnod a 6 számjegyű kódot 30 napig.',
    
    current: 'Jelenlegi eszköz',
    browser: 'Böngésző',
    os: 'Operációs rendszer',
    ip: 'IP cím',
    addedAt: 'Hozzáadva',
    expiresAt: 'Lejár',
    lastUsed: 'Utoljára használva',
    
    remove: 'Eltávolítás',
    removeAll: 'Összes eltávolítása',
    
    empty: 'Nincsenek megbízható eszközök',
    
    messages: {
      removed: 'Eszköz eltávolítva!',
      removedAll: 'Összes eszköz eltávolítva!',
      error: 'Hiba az eszköz eltávolítása során',
      confirmRemove: 'Biztosan eltávolítod ezt az eszközt?',
      confirmRemoveAll: 'Biztosan eltávolítod az összes megbízható eszközt?',
    },
  },

  settings: {
    title: 'Kétfaktoros hitelesítés',
    description: 'Kezeld a kétfaktoros hitelesítés beállításait',
    
    status: {
      title: 'Státusz',
      enabled: 'Bekapcsolva',
      disabled: 'Kikapcsolva',
      enrolledAt: 'Bekapcsolva:',
      lastUsed: 'Utoljára használva:',
      never: 'Soha',
    },

    actions: {
      enable: 'MFA bekapcsolása',
      disable: 'MFA kikapcsolása',
      reconfigure: 'Újrakonfigurálás',
      viewBackupCodes: 'Backup kódok megtekintése',
      manageTrustedDevices: 'Megbízható eszközök kezelése',
    },

    disable: {
      title: 'MFA kikapcsolása',
      description: 'Biztosan kikapcsolod a kétfaktoros hitelesítést? Ez csökkenti a fiókod biztonságát.',
      passwordRequired: 'Add meg a jelszavadat a megerősítéshez:',
      confirm: 'Kikapcsolás',
      cancel: 'Mégse',
      success: 'Kétfaktoros hitelesítés kikapcsolva',
      error: 'Hiba az MFA kikapcsolása során',
    },
  },

  admin: {
    title: 'MFA adminisztráció',
    description: 'Szervezeti szintű MFA beállítások és felhasználó kezelés',
    
    policy: {
      title: 'MFA szabályzat',
      required: 'MFA kötelező az összes felhasználónak',
      gracePeriod: 'Türelmi időszak (napok)',
      allowBackupCodes: 'Backup kódok engedélyezése',
      allowTrustedDevices: 'Megbízható eszközök engedélyezése',
      trustedDeviceDays: 'Megbízható eszköz érvényessége (napok)',
      save: 'Mentés',
      saved: 'MFA szabályzat mentve!',
    },

    users: {
      title: 'Felhasználók MFA státusza',
      search: 'Keresés felhasználók között...',
      name: 'Név',
      email: 'Email',
      status: 'MFA státusz',
      enrolledAt: 'Bekapcsolva',
      actions: 'Műveletek',
      reset: 'MFA reset',
      resetConfirm: 'Biztosan visszaállítod {name} MFA beállításait?',
      resetSuccess: 'MFA sikeresen visszaállítva!',
      resetError: 'Hiba az MFA visszaállítása során',
    },

    stats: {
      title: 'Statisztikák',
      totalUsers: 'Összes felhasználó',
      mfaEnabled: 'MFA bekapcsolva',
      mfaDisabled: 'MFA kikapcsolva',
      percentage: 'MFA használat',
    },
  },

  activity: {
    title: 'MFA aktivitás napló',
    description: 'Az összes MFA esemény naplója',
    
    types: {
      setup: 'MFA bekapcsolva',
      verify: 'Bejelentkezés MFA-val',
      disable: 'MFA kikapcsolva',
      backup_code_used: 'Backup kód használva',
      trusted_device_added: 'Megbízható eszköz hozzáadva',
      trusted_device_removed: 'Megbízható eszköz eltávolítva',
    },

    columns: {
      timestamp: 'Időpont',
      type: 'Esemény',
      status: 'Státusz',
      ip: 'IP cím',
      details: 'Részletek',
    },

    status: {
      success: 'Sikeres',
      failed: 'Sikertelen',
    },

    empty: 'Nincs MFA aktivitás',
  },
};
